jQuery(document).ready(function () {
	const subnav = jQuery("[data-subnav='subnav']");
	
	
	const subnav_now = subnav.find('.subnav__now');
	const subnav_now_text = subnav_now.find("[data-navbar='now']")
	const subnav_now_icon = subnav_now.find('.icon-icon-chevron-down');

	
	const subnav_list = subnav.find('.subnav__list');
	const subnav_link_active = subnav_list.find('.subnav__link.active');
	
	
	let subnav_link_active_text;

	if (subnav_link_active.text() === '') {
		subnav_link_active_text = 'Link Actual';
	} else {
		subnav_link_active_text = subnav_link_active.text();
	}

	
	subnav_now_text.text(subnav_link_active_text);

	
	subnav.click(function () {
		subnav_list.slideToggle();
		subnav_now_icon.toggleClass('active');
	});
});